import BaseStimulusModelController from "../../../BaseStimulusModelController";
import { DestinationSearchStimulusModel } from "../../../../scripts/_generated/DestinationSearchStimulusModel";

export default class BluetoothBeaconsEditorController extends BaseStimulusModelController<DestinationSearchStimulusModel> {
    static targets = [
        "instances",
        "instanceTemplate",
        "instanceNumber",
        "instanceRadiusInMeters"
    ];

    readonly instancesTarget!: HTMLElement;
    readonly instanceTemplateTarget!: HTMLElement;
    readonly instanceNumberTargets!: HTMLInputElement[];
    readonly instanceRadiusInMetersTargets!: HTMLInputElement[];

    connect() {
    }

    addInstance() {
        maxNumber = 0;
        if (this.instanceNumberTargets.length > 1) {
            var numbers = this.instanceNumberTargets.map(x => new Number(x.value) as number);
            var maxNumber = Math.max(...numbers);
            if (maxNumber == 255) return;
        }

        this.instancesTarget.insertAdjacentHTML("beforeend", this.instanceTemplateTarget.innerHTML);
        const newInstanceIndex = this.instanceNumberTargets.length - 2;
        const newInstanceNumber = this.instanceNumberTargets[newInstanceIndex];
        newInstanceNumber.value = `${maxNumber + 1}`;
        newInstanceNumber.name = newInstanceNumber.name.replace("{i}", `${newInstanceIndex}`);

        const instanceRadiusInMeters = this.instanceRadiusInMetersTargets[newInstanceIndex];
        instanceRadiusInMeters.name = instanceRadiusInMeters.name.replace("{i}", `${newInstanceIndex}`);
    }

    removeInstance(event: Event) {
        const instanceToRemove = (event.currentTarget as Element).closest(".instance");
        if (!instanceToRemove) throw new Error("Cannot find parent instance.")
        instanceToRemove.remove();

        this.updateInstancesIndex();
    }

    updateInstancesIndex() {
        const indexInBracketsRegexPattern = /\[\d+\]/;
        this.instanceNumberTargets.forEach((instanceNumber, i) => {
            instanceNumber.name = instanceNumber.name.replace(indexInBracketsRegexPattern, `[${i}]`);
        });
        this.instanceRadiusInMetersTargets.forEach((instanceRadiusInMeters, i) => {
            instanceRadiusInMeters.name = instanceRadiusInMeters.name.replace(indexInBracketsRegexPattern, `[${i}]`);
        });
    }
}

